import DataTableReadDto from "../../classes/dtos/pathcommonmodule/DataTableReadDto";
import DataTableParametersDto from "../../classes/dtos/pathcommonmodule/DataTableParametersDto";
import DataSourceDataTableReadDto from "../../classes/dtos/pathcommonmodule/DataSourceDataTableReadDto";
import PathDataTableReadDto from "../../classes/dtos/pathcommonmodule/PathDataTableReadDto";
import DataTableIterationLinkDto from "../../classes/dtos/pathcommonmodule/DataTableIterationLinkDto";
import DataProviderType from "../../classes/consts/DataProviderType";
import GroupFilterMapper from "./GroupFilterMapper";

export default class DataTableReadMapper {

    static ToDto(e: any): DataTableReadDto | null {

        if (e == null) {
            return null;
        }

        let result: DataTableReadDto | null = null;

        if (e.$type === DataProviderType.DataSource) {
            result = new DataSourceDataTableReadDto(e.dataSourceId, e.dataSourceLabel, e.dataSourceTypeId, e.dataSourceTypeLabel, e.databaseReferenceId, e.databaseReferenceLabel, e.tableReferenceId, e.tableReferenceLabel);
        }

        if (e.$type === DataProviderType.PathDataTable) {
            result = new PathDataTableReadDto(e.pathId, e.pathName);
        }

        if (result == null) {
            alert(e.$type + " not managed");
            return null;
        }

        if (e.parameters != null) {
            const parameters = new DataTableParametersDto();
            parameters.Filter = GroupFilterMapper.ToDto(e.parameters.filter);
            parameters.Iteration = DataTableReadMapper.ToDto(e.parameters.iteration);
            parameters.IterationLinks = ((e.parameters.iterationLinks ?? []) as any[]).map((l) =>
                new DataTableIterationLinkDto(l.fieldReferenceId, l.parameterDefinitionId ?? 0, l.parameterTechnicalName ?? ""));
            result.Parameters = parameters;
        }

        return result;
    }

    static ToPayload(e: DataTableReadDto | null): object | null {

        if (e == null) {
            return null;
        }

        const parametersPayload = e.Parameters == null ? null : {
            Filter: GroupFilterMapper.ToPayload(e.Parameters.Filter),
            Iteration: DataTableReadMapper.ToPayload(e.Parameters.Iteration),
            IterationLinks: (e.Parameters.IterationLinks ?? []).map((l) => ({
                FieldReferenceId: l.FieldReferenceId,
                ParameterDefinitionId: l.ParameterDefinitionId,
                ParameterTechnicalName: l.ParameterTechnicalName
            }))
        };

        if (e instanceof DataSourceDataTableReadDto) {

            let result = {
                $type: DataProviderType.DataSource,
                DataSourceId: e.DataSourceId,
                DatabaseReferenceId: e.DatabaseReferenceId,
                TableReferenceId: e.TableReferenceId,
                TableReferenceLabel: e.TableReferenceLabel,
                Parameters: parametersPayload
            }
            return result;
        }

        if (e instanceof PathDataTableReadDto) {

            let result = {
                $type: DataProviderType.PathDataTable,
                PathId: e.PathId,
                Parameters: parametersPayload
            }
            return result;
        }

        return null;
    }
}